import { api } from '@/plugins'
import {
  GET_CHEQUES,
  GET_CHEQUES_SUCCESS,
  GET_CHEQUES_FAIL
} from './mutations'

export default {
  list ({ commit }) {
    return new Promise((resolve, reject) => {
      commit(GET_CHEQUES)

      api
        .GET('cheque/list')
        .then(async datas => {
          await commit(GET_CHEQUES_SUCCESS, datas)
          resolve(datas)
        })
        .catch(e => {
          commit(GET_CHEQUES_FAIL)
          reject(e)
        })
    })
  }
}
